<template>
  <main class="conditions">
    <div class="text">
      <div
        class="li flex"
        v-for="(condition, index) in conditions"
        :key="index"
      >
        <div class="sli top lundi">{{ condition.title }}</div>
        <div class="sli" v-html="condition.text"></div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "conditions",
  data() {
    return {
      lang: "en"
    };
  },
  created() {
    if (this.$store.state.conditions.length === 0) {
      this.$store.dispatch("loadConditions");
    }
  },
  computed: {
    conditions() {
      return this.$store.state.conditions;
    }
  }
};
</script>

<style lang="scss" scoped>
.conditions {
  display: grid;
  grid-template-columns: minmax(auto, 700px) 1fr;
  grid-gap: var(--lh);
  .top {
    // white-space: nowrap;
  }
  @media only screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    .top {
      white-space: normal;
    }
  }
}
</style>
